import Checking from './Checking';
import Error from './Error';
import Pending from './Pending';
import Referred from './Referred';
import SignDocuments from './SignDocuments';

const Humm = {
  Pending,
  SignDocuments,
  Referred,
  Checking,
  Error,
};

export default Humm;
